import { useEffect } from 'react';

// Shared cache across the app to prevent multiple loads
const cache = new Set();

// Preload a single image and add to cache
const preloadImage = (src) => {
  if (!src || cache.has(src)) return Promise.resolve(src);
  
  return new Promise((resolve) => {
    cache.add(src);
    const img = new Image();
    img.onload = () => resolve(src);
    img.onerror = () => resolve(null);
    img.src = src;
  });
};

// Hook for preloading multiple images
export const useImagePreloader = (images, eager = false) => {
  useEffect(() => {
    if (!images || images.length === 0) return;

    // Convert to array if needed
    const imageArray = Array.isArray(images) ? images : [images];
    const imageSrcs = imageArray.map(img => typeof img === 'string' ? img : img.src);
    
    if (eager) {
      // Load immediately in parallel
      Promise.all(imageSrcs.map(preloadImage));
    } else {
      // Stagger loads to prevent network congestion
      imageSrcs.forEach((src, i) => {
        setTimeout(() => {
          preloadImage(src);
        }, i * 200);
      });
    }
  }, [images, eager]);
};

export { preloadImage };